import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileBlock',
  props: {
    link: { type: Boolean },
    to: null,
    inline: { type: Boolean },
    wide: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any) {





return { __sfc: true, }
}

})